module.exports = __webpack_public_path__ + "img/PC.0e3e9e96.png";